import { Dispatch, SetStateAction } from 'react'

import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import { Button, FieldLabel, Flex, Input, PaddingInset, spacing, Stack, Text } from '@cash-design-system/react'

const StyledFieldLabel = styled(FieldLabel)`
  margin: ${({ theme: { spacing } }) => `${spacing.m} ${spacing.empty} ${spacing.l} ${spacing.empty}`};
`

export const EditFormName = ({
  handleBackToCanvasView,
  setUserInputtedName,
  userInputtedName,
}: {
  handleBackToCanvasView: (shouldClearUserInput?: boolean) => void
  setUserInputtedName: Dispatch<SetStateAction<string>>
  userInputtedName: string
}) => {
  const { t } = useTranslation()
  const handleKeyDown = (e: React.KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === 'Enter' && !!userInputtedName) {
      handleBackToCanvasView()
    }
  }

  return (
    <Stack space={spacing.xl} onKeyDown={e => handleKeyDown(e)}>
      <PaddingInset>
        <Stack space={spacing.m}>
          <Text typography="numeralSmall" as="h2" color="textStandard">
            {t('Edit name on this form', { context: 'modal title text.' })}
          </Text>
          <Text typography="body" color="textSubtle">
            {t('This will update what appears on this form, but won’t change anything else on Cash App.', {
              context: 'modal subtext.',
            })}
          </Text>
        </Stack>
      </PaddingInset>
      <StyledFieldLabel
        label={t('Full name', {
          context: 'Name input label.',
        })}
      >
        <Input value={userInputtedName} onChange={e => setUserInputtedName(e.target.value)} />
      </StyledFieldLabel>
      <Flex justifyContent="space-between" alignItems="center" gap={spacing.m}>
        <Button size="large" variant="secondary" onClick={() => handleBackToCanvasView(true)}>
          {t('Cancel', { context: 'button text' })}
        </Button>
        <Button size="large" variant="primary" disabled={!userInputtedName} onClick={() => handleBackToCanvasView()}>
          {t('Save', { context: 'modal text button.' })}
        </Button>
      </Flex>
    </Stack>
  )
}
